import { StyleSheet } from 'aphrodite';
import { grayIconFill } from '../../../web/styles/colors';
import { CssSelectors } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		height: '100%',
	},
	content: {
		height: `calc(100% - ${80}px)`,
		paddingBottom: 20,
	},
	contentContainer: {
		':hover': {
			cursor: 'pointer',
		},
		...CssSelectors.allChildren(
			{
				fontSize: 14,
			},
			':first-child:not(.tag):not(.saved-search)'
		),
		...CssSelectors.allChildren(
			{
				alignItems: 'center',
				display: 'flex',
				marginLeft: 8,
				textTransform: 'capitalize',
			},
			':last-child'
		),
		...CssSelectors.allChildren(
			{
				marginLeft: 0,
			},
			'.saved-search'
		),
	},
	flex: {
		display: 'flex',
	},
	itemContainer: {
		':last-child': {
			marginBottom: 0,
		},
		marginBottom: 8,
	},
	pill: {
		fontSize: 14,
		padding: '5px 10px',
		...CssSelectors.allChildren(
			{
				height: 13,
				marginRight: 8,
				width: 13,
			},
			'svg'
		),
		...CssSelectors.allChildren(
			{
				marginRight: 5,
				width: 25,
			},
			'img'
		),
	},
	textLight: {
		color: grayIconFill,
		fontSize: 14,
		fontStyle: 'italic',
	},
	title: {
		fontSize: 14,
		marginBottom: 22,
		paddingTop: 10,
	},
});
